module.exports = __webpack_public_path__ + "img/success_OLD_c.7dfe01b7.gif";